import type { Products_content_listProducts_discountedPrice } from '@/queries/types/Products';

const isFreeRing = (
  discountedProductPrice: Products_content_listProducts_discountedPrice,
): boolean => {
  const originalAmount: number | null =
    discountedProductPrice.originalPrice?.amount ?? null;
  const discountedAmount: number | null =
    discountedProductPrice.discountedPrice?.amount ?? null;
  const parsedPrice = Number(originalAmount);

  if (!originalAmount || !discountedAmount) return true;

  return Math.max(parsedPrice - (originalAmount - discountedAmount), 0) === 0;
};

export default isFreeRing;
